import {
  GetFirmsResponse,
  GetFirmsRequest,
  CreateFirmResponse,
  CreateFirmRequest,
  UpdateFirmResponse,
  UpdateFirmRequest,
} from "@shared/apiSchemas/support";
import { cmaBackendApi, TagTypes } from "../api";

const _support_firmsApi = cmaBackendApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * getFirms
     */
    getFirms: build.query<GetFirmsResponse, GetFirmsRequest>({
      query: ({ paginationQuery }) => {
        let params = new URLSearchParams();
        if (paginationQuery) {
          params.append("page", paginationQuery.page.toString());
          params.append("pageSize", paginationQuery.pageSize.toString());
          if (paginationQuery.sortBy) {
            params.append("sortBy", paginationQuery.sortBy);
          }
          if (paginationQuery.sortOrder) {
            params.append("sortOrder", paginationQuery.sortOrder);
          }
        }
        return {
          url: `/support/firms`,
          method: "GET",
          params,
        };
      },
      providesTags: (results) => [
        { type: TagTypes.Firms },
        ...(results
          ? results.firms.map((firm) => ({
              type: TagTypes.Firms,
              firmId: firm.id,
            }))
          : []),
      ],
    }),

    /**
     * createFirm
     */
    addNewFirm: build.mutation<CreateFirmResponse, CreateFirmRequest>({
      query: (createFirmRequest) => ({
        url: `/support/firms`,
        method: "POST",
        data: createFirmRequest,
      }),
      invalidatesTags: [{ type: TagTypes.Firms }],
    }),

    /**
     * updateFirm
     */
    updateFirm: build.mutation<
      UpdateFirmResponse,
      UpdateFirmRequest & { firmId: string }
    >({
      query: ({ firmId, ...data }) => ({
        url: `/support/firms/${firmId}`,
        method: "PUT",
        data,
      }),
      invalidatesTags: (_, __, { firmId }) => [
        { type: TagTypes.Firms },
        { type: TagTypes.Firms, firmId },
      ],
    }),
  }),
});

export const {
  useGetFirmsQuery,
  useLazyGetFirmsQuery,
  useAddNewFirmMutation,
  useUpdateFirmMutation,
} = _support_firmsApi;
